import React from "react";
import { shallowEqual } from "react-redux";
import styles from "./Summary.module.scss";
import { useCarConfigSelector } from "../../../../../redux/store";
import CtaButton from "../../../common/cta/CtaButton";
import { summaryCtaSelector } from "../../../../../utils/selectorUtils";
import { useAphBreakpoint } from "../../../../../../shared-logic/hooks/useBreakpoint";

const SummaryCTA: React.FC = () => {
    const isMobile = useAphBreakpoint("down", "xl");
    const overviewCtaConfig = useCarConfigSelector(summaryCtaSelector(isMobile), shallowEqual);

    if (!overviewCtaConfig || overviewCtaConfig?.length === 0) return null;
    const primaryCtaConfigurations = overviewCtaConfig.filter((cta) => cta.isPrimary);
    const secondaryCtaConfigurations = overviewCtaConfig.filter((cta) => !cta.isPrimary);

    return (
        <div>
            {/* Primary CTA's: Always shown first */}
            {primaryCtaConfigurations.length > 0 && (
                <div className={styles.ctas}>
                    {primaryCtaConfigurations.map((cta) => (
                        <CtaButton
                            ctaConfig={cta}
                            sizing="full-width"
                            key={`${cta.type as string}-${cta.title}`}
                            useOrderCtaTracking
                        />
                    ))}
                </div>
            )}
            {secondaryCtaConfigurations.length > 0 && (
                <div className={styles.ctas}>
                    {/* Secondary Cta's: Always shown last */}
                    {secondaryCtaConfigurations.map((cta) => (
                        <div className={styles.cta} key={`${cta.type as string}-${cta.title}`}>
                            <CtaButton ctaConfig={cta} sizing="full-width" useOrderCtaTracking />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SummaryCTA;
